module.exports = __webpack_public_path__ + "img/msg07.5a4dbaba.png";